import { render } from "./TheAdminPatientsList.vue?vue&type=template&id=0d5ecda2&ts=true"
import script from "./TheAdminPatientsList.vue?vue&type=script&lang=ts"
export * from "./TheAdminPatientsList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__